/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Sign_In_DetailsInputs */



/**
* | output |
* | --- |
* | "Sign in to view full tournament details." |
*
* @param {Tournament_Sign_In_DetailsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_sign_in_details = /** @type {((inputs?: Tournament_Sign_In_DetailsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Sign_In_DetailsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connectez-vous pour voir tous les détails du tournoi.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inicie sesión para ver los detalles completos del torneo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Faça login para ver os detalhes completos do torneio.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Accedi per visualizzare i dettagli completi del torneo.")
	return /** @type {LocalizedString} */ ("Sign in to view full tournament details.")
});